import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js';
import React from 'react';
import MyListing from '@/Pages/MyListing';

export * from './FeaturedStatusFragment';
export const MyListingsFragment = () => {
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

    return (
        <Elements stripe={stripePromise}>
            <MyListing />
        </Elements>
    )
}
